import React from 'react'
import { Title } from '../pages/public/Title'
import Shield from './Shield'

import { ReactComponent as BallIcon } from '../assets/icons/ball.svg'
import { useNavigate } from 'react-router-dom'
const TeamTitle = ({ team }) => {
    const navigate = useNavigate()
    return (
        <Title
            backgroundColor={'var(--colors-primary-accent)' || team?.colors[0]}
        >
            <Shield
                width="1.25rem"
                height="1.5rem"
                style={{
                    marginBottom: '0.5rem',
                    marginRight: '1.25rem',
                }}
                primaryColor={team?.colors[0]}
                secondaryColor={team?.colors[1]}
                onClick={() => navigate('.')}
            ></Shield>
            {team?.name}
            <BallIcon style={{ height: '2rem' }} />
        </Title>
    )
}

export default TeamTitle
